export default __webpack_public_path__ + "static/media/t5.75886a23.png";